"use client";

import { useSearchParams } from "next/navigation";
import { useRouter } from "@/i18n/navigation";
import { useEffect } from "react";
import { ROUTES } from "@/constants";

export default function RootPage() {
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const error = searchParams.get('error');

    if (code || error) {
      // Redirect to social-signin page with params
      const params = new URLSearchParams();
      if (code) params.set('code', code);
      const state = searchParams.get('state');
      if (state) params.set('state', state);
      if (error) {
        params.set('error', error);
        const errorDescription = searchParams.get('error_description');
        if (errorDescription) params.set('error_description', errorDescription);
      }
      router.push(`${ROUTES.SOCIAL_SIGNIN}?${params.toString()}`);
    } else {
      // Redirect to home
      router.replace('/home');
    }
  }, [searchParams, router]);

  return null;
}
